import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { arrayOf, func } from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import {
  mediaSetRequirementShape,
  requirementShape,
} from '../../../prop-types';
import abbreviateDuration from '../../../utils/abbreviate-duration';
import abbreviateFileSize from '../../../utils/abbreviate-file-size';
import { CREATIVE_FILE_TYPES } from '../../constants';
import PossibleMediaSets from './PossibleMediaSets';
import SizeThumbnail from './SizeThumbnail';

class RequirementsGuide extends React.Component {
  componentDidMount() {
    this.props.fetchMediaSetRequirements();
  }

  render() {
    const { requirements, mediaSetRequirements } = this.props;

    if (isEmpty(requirements)) return null;

    return (
      <>
        <h5 className="h6">Requirements</h5>
        <Row className="text-muted small">
          {requirements.map(requirement => {
            const {
              sizeType,
              id,
              requirements: {
                fileType,
                fileFormat,
                fileSize,
                minDuration,
                maxDuration,
              },
            } = requirement;

            return (
              <Col sm={4} key={id}>
                <div className="d-flex align-items-top border rounded p-2">
                  <SizeThumbnail requirement={requirement} />
                  <div className="ml-3">
                    <h6 data-qa-field="sizeType">{sizeType}</h6>
                    <div
                      data-qa-field="fileType"
                      className="font-weight-bold mb-1"
                    >
                      {CREATIVE_FILE_TYPES[fileType]}
                    </div>
                    <div data-qa-field="fileFormat">
                      {isArray(fileFormat) ? fileFormat.join(', ') : fileFormat}
                    </div>
                    <div data-qa-field="fileSize">
                      Max size - {abbreviateFileSize(parseInt(fileSize, 10))}
                    </div>
                    {minDuration && (
                      <div data-qa-field="minDuration">
                        Min duration -{' '}
                        {abbreviateDuration(parseInt(minDuration, 10))}
                      </div>
                    )}
                    {maxDuration && (
                      <div data-qa-field="maxDuration">
                        Max duration -{' '}
                        {abbreviateDuration(parseInt(maxDuration, 10))}
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
        <div className="mb-4" />
        <h6>Possible media set combinations</h6>
        <PossibleMediaSets
          requirements={requirements}
          mediaSetRequirements={mediaSetRequirements}
        />
      </>
    );
  }
}

RequirementsGuide.propTypes = {
  requirements: arrayOf(requirementShape.isRequired),
  mediaSetRequirements: arrayOf(mediaSetRequirementShape.isRequired).isRequired,
  fetchMediaSetRequirements: func.isRequired,
};

RequirementsGuide.defaultProps = {
  requirements: [],
};

export default RequirementsGuide;
